export default function ProgressBar({ pct, height = 6 }: { pct: number; height?: number }) {
  const clamped = Math.max(0, Math.min(100, pct))
  const color =
    clamped > 95 ? 'var(--danger)' : clamped > 80 ? 'var(--warn)' : 'var(--gold)'
  return (
    <div className="pbar" style={{ height }}>
      <div className="pbar-fill" style={{ width: `${clamped}%`, background: color }} />
    </div>
  )
}
